// External libraries
import React from 'react';
import { func } from 'prop-types';
import { useStoreState } from 'easy-peasy';
import { Checkbox, FieldError, TextButton } from '@checkout/react-components';

// Internal modules
import { clickHandler } from './handlers';
import { getContent } from '@/lib';
import { checkboxLabelStyleOverrides } from '@/styles';
import { errorStyleOverrides, sepaButtonStyles } from './styles';

const sepaDirectDebitButton = () => ({
  sepaDirectDebit: (
    <TextButton onClick={clickHandler} styleOverrides={sepaButtonStyles}>
      {getContent('sepa.directDebit')}
    </TextButton>
  ),
});

const SepaMandate = ({ changeHandler }) => {
  const isFormSubmitting = useStoreState(({ ui }) => ui.isFormSubmitting);
  const sepaMandate = useStoreState(({ form }) => form.sepaMandate);
  const hasError = Boolean(sepaMandate?.displayError);

  return (
    <>
      <Checkbox
        aria-describedby={hasError ? 'sepaMandate-error' : null}
        aria-invalid={hasError}
        changeHandler={changeHandler}
        checked={sepaMandate.value}
        disabled={isFormSubmitting}
        id="sepaMandate"
        label={getContent('sepa.legalAgreement', sepaDirectDebitButton())}
        labelStyleOverrides={checkboxLabelStyleOverrides}
        name="sepaMandate"
        required={true}
        {...sepaMandate}
      />
      {hasError && (
        <FieldError
          id="sepa-mandate-error"
          styleOverrides={errorStyleOverrides}
        >
          {getContent('fieldErrors.signupTermsMissing')}
        </FieldError>
      )}
    </>
  );
};

SepaMandate.propTypes = {
  changeHandler: func,
};

export { SepaMandate };
